import { createAsyncLocalStorage } from './async-local-storage';
export const afterTaskAsyncStorageInstance = createAsyncLocalStorage();

//# sourceMappingURL=after-task-async-storage-instance.js.map